﻿export const SHOW_ALERT = (state, parameters) => {
    state.alertModal.show = true;
    state.alertModal.header = parameters.header;
    state.alertModal.body = parameters.body;
    state.alertModal.footer = parameters.footer;
    state.alertModal.hideButton = parameters.hideButton;
};

export const HIDE_ALERT = (state) => {
    state.alertModal.show = false;
};

export const VALIDATE_FORM_BLOCK = (state, block) => {
    const newform = state.form;
    newform[block.index] = block;
    state.form = [];
    state.form = newform;
};

export const REGISTER_FORM_BLOCK = (state, block) => {
    state.form.push(block);
};

export const VALIDATE_PARTIAL_BLOCK = (state, block) => {
    const newpartial = state.partial;
    newpartial[block.index] = block;
    state.partial = [];
    state.partial = newpartial;
};

export const REGISTER_PARTIAL_BLOCK = (state, block) => {
    state.partial.push(block);
};

export const GET_DIVA_CONTRACTS = (state, loaderData) => {     
    // console.log(loaderData)
    
    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.alertModal.message = loaderData.popupMessage;
    state.contracts.divaContracts= null;  
    state.contracts.showDivaContracts = false;
}


export const STORE_DIVA_CONTRACTS = (state, divaContracts, error) => {     
    let binaryData= divaContracts.BinaryData;
    let fileName= divaContracts.FileName;  
    if(binaryData === "") {
        SHOW_MODAL(state,{'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh']});        
    }
    else{
        //state.contracts.showTeliaContracts = true;
        SHOW_CONTRACTS(binaryData, fileName, state); 
        //SHOW_MODAL(state,{'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh']});        
    }
}

export const GET_SIGN_PORTINGS = (state, loaderData) => { 
    
    state.pageLoader.showLoader = true; 
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.alertModal.message = loaderData.popupMessage;
    state.contracts.signedPortings= null;      
}

export const STORE_SIGN_PORTINGS = (state, result, error) => {

    var obj = JSON.parse(result);
    //state.pageLoader.showLoader = false;
    if (obj.Error === true) {
        state.pageLoader.showLoader = false;
        state.contracts.signedPortings = obj.PortingDigitalValidationViewModel.EpoaPortings;
        SHOW_MODAL(state,
        {
            'context': 'contracts',
            'errorState': true,
            'icon': 'info',
            'showHeadline': false,
            'messageContent': [],
            'buttons': ['refresh'],
            'refresh': false
        });
    } else {
        //document.getElementById("digitalvalidation-next").disabled = true; 
        document.getElementById("digitalvalidation-form").submit(); 
    }   
}

export const GET_UPDATE_PORTING_DETAILS = (state, loaderData) => {     
    //state.pageLoader.showLoader = true;
    state.contracts.simSaved = false;
    //state.pageLoader.loaderTitle = loaderData.loaderTitle;
    //state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.alertModal.message = loaderData.popupMessage;
}
export const STORE_UPDATE_PORTING_DETAILS = (state, result, error) => {       
   // state.pageLoader.showLoader = false;
    if (result !== 'False') {
        SHOW_MODAL(state,
        {
            'context': 'contracts',
            'errorState': true,
            'icon': 'info',
            'showHeadline': false,
            'messageContent': [],
            'buttons': ['refresh'],
            'refresh': true
        });
        //window.location.reload();
    } else {
        state.contracts.simSaved = true;
    }
//document.getElementById("digitalvalidation-form").submit(); 
}

export const SHOW_CONTRACTS = (binaryData, fileName, state) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
        state.pageLoader.showLoader = false;
        var byteCharacters = atob(binaryData);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: 'application/pdf' });
        window.navigator.msSaveOrOpenBlob(blob, fileName + '.pdf');
    } else {
        state.pageLoader.showLoader = false;
        var byteCharacters = atob(binaryData);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: 'application/pdf' });
        var URL = window.URL;
        var downloadUrl = URL.createObjectURL(blob);

        //  download('file.pdf', blob);
        // openInNewTab(downloadUrl);
        // document.location.href = downloadUrl;

        // window.open(downloadUrl);

        var redirectWindow = window.open('', '_blank');
        if (redirectWindow === null) {
            var downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = fileName + '.pdf';
            downloadLink.href = downloadUrl;
            document.body.append(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadUrl);
        } else {
            redirectWindow.location.href = downloadUrl;
        }

    }
}

export const SHOW_MODAL = (state, data, exception) => {
    state.pageLoader.showLoader = false;        
    state.alertModal.buttons = data.buttons;
    state.alertModal.icon = data.icon;    
    state.alertModal.show = true;
    state.alertModal.refresh = data.refresh;
    if (data.message !== undefined) {
        state.alertModal.message = data.message;
    }
}

export const HIDE_MODAL = (state) => {
    state.alertModal.show = false;
}

export const SHOW_LOADER = (state, loaderData) => {
    //state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
}

export const HIDE_LOADER = (state) => {
    state.pageLoader.showLoader = false;
}

export const GET_NON_PORTING_CONTRACTS = (state, loaderData) => {     
    //console.log("myyyloader");
    state.pageLoader.showLoader = true;
    state.alertModal.message = loaderData.errorMessage;
    state.pageLoader.loaderTitle = loaderData.loaderTitle; 
    state.pageLoader.loaderMessage = loaderData.loaderMessage; 
}

export const STORE_NON_PORTING_CONTRACTS = (state, result, error) => {
    //if (result.HttpResponseStatusCode !== 200) {
    //    console.log("error");
    //}
    
    state.pageLoader.showLoader = false;
}

export const GET_NON_PORTING_CONTRACTS_BTC = (state, loaderData) => {
    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.alertModal.message = loaderData.errorMessage;
}

export const STORE_NON_PORTING_CONTRACTS_BTC = (state, result, error) => {
    //if (result.HttpResponseStatusCode !== 200) {
    //    console.log("error");
    //}
    
    state.pageLoader.showLoader = false;
}

export const GET_APPROVE_ORDER_BY_CUSTOMER = (state, loaderData) => {
    //if (result.HttpResponseStatusCode !== 200) {
    //    console.log("error in approve order");
    //}
     
    state.pageLoader.showLoader = true;
    state.alertModal.message = loaderData.errorMessage;
    state.pageLoader.loaderTitle = loaderData.loaderTitle; 
    state.pageLoader.loaderMessage = loaderData.loaderMessage; 
}

export const STORE_APPROVE_ORDER_BY_CUSTOMER = (state, result, error) => {
    state.pageLoader.showLoader = false;    

    var obj = JSON.parse(result);
    if (obj.IsInErrorState !== false) {
        // throw new exception and then handle this exception one level higher
        throw obj.Message;
    } else {
        JUMP_NEXT_PAGE(state);
    }        
}

export const GET_APPROVE_ORDER_BY_CUSTOMER_BTC = (state, loaderData) => {
    //if (result.HttpResponseStatusCode !== 200) {
    //    console.log("error");
    //}
     
    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.alertModal.message = loaderData.errorMessage;
}

export const JUMP_NEXT_PAGE = (state) => {
    state.pageLoader.showLoader = false;
    document.getElementById("digitalvalidation-form").submit();
}

export const GET_PAGE_OVERVIEW  = (state) => {
    //var obj = JSON.parse(result);
    //console.log(obj)
    state.pageOverview = null;
}

export const STORE_PAGE_OVERVIEW  = (state, pageOverview) => {
    //var obj = JSON.parse(result)      
    state.pageOverview = pageOverview.pageOverview;    
}

export const GET_DELIVERY_ADDRESS  = (state) => {
    //var obj = JSON.parse(result);
    //console.log(obj)
    state.deliveryAddress = null;
}

export const STORE_DELIVERY_ADDRESS  = (state, deliveryAddress) => {
    //var obj = JSON.parse(result)      
    state.deliveryAddress = deliveryAddress.deliveryAddress;    
}

export const GET_CANCEL_ORDER = (state, loaderData) => {
    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
}

export const STORE_CANCEL_ORDER = (state, result, error) => {
    state.pageLoader.showLoader = false;
    state.cancelation.orderCanceled = true;
    state.cancelation.showCancelOrderModal = true;
}

export const GET_UPLOAD_DOCUMENT = (state, loaderData) => { 
    
    state.pageLoader.showLoader = true; 
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.alertModal.message = loaderData.popupMessage;       
}

export const STORE_UPLOAD_DOCUMENT = (state, result, error) => {

    var obj = JSON.parse(result);    
    state.pageLoader.showLoader = false;
    if (obj === 0) {     
        SHOW_MODAL(state,
        {
            'context': 'contracts',
            'errorState': true,
            'icon': 'info',
            'showHeadline': false,
            'messageContent': [],
            'buttons': ['refresh'],
            'refresh': false
        });
    }   
}

export const GET_INIT_PAYMENT_LOADER = (state, loaderData) => { 
    state.pageLoader.showLoader = true; 
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
}

export const GET_CREDIT_CARD_RETURN_URL = (state, result, error) => {
    var url = decodeURIComponent(result);

    state.pageLoader.showLoader = false; 

    self.location = JSON.parse(url);
    //window.location.replace(JSON.parse(url));
}

export const GET_REDIRECT_TO_URL = (state, data) => {
    state.pageLoader.showLoader = true; 
    state.pageLoader.loaderTitle = data.loaderData.loaderTitle;
    state.pageLoader.loaderMessage = data.loaderData.loaderMessage;

    var url = decodeURIComponent(data.url);

    self.location = url;
    //window.location.replace(url);
}